var render = function render(_c,_vm){return _c('div',{staticClass:"notification-panel__notification-user-initials"},[_vm._v("\n  "+_vm._s(_vm._f("nameAbbreviation")(_vm.props.notification.sender?.first_name))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }